// The tenant website's first path segment is expected to be a locale - either a bare 2-letter
// country code ("https://send.asendia.com/au" -> "/au") or a language-region tag ("/it-es").
// Falls back to '' (not "/") if that isn't the case, so tenants without a locale segment get a
// clean path with no double slash.
export function GetTenantLocaleFromWebsite(website: string): string {
  if (!website) return '';
  try {
    const segment = new URL(website).pathname.split('/').filter(Boolean).pop();
    return segment && /^[a-z]{2}(-[a-z]{2})?$/i.test(segment) ? `/${segment.toLowerCase()}` : '';
  } catch {
    return website;
  }
}
